<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChanged($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', maxWidth: '95vw' }"
  [contentStyle]="{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }"
  [header]="'FLEXI_SETTINGS.BULK_TITLE' | translate"
>
  <div class="fab">
    <section class="fab-section">
      <h4 class="fab-heading">
        {{ (businesses.length === 1 ? 'FLEXI_SETTINGS.BULK_SUBTITLE_ONE' : 'FLEXI_SETTINGS.BULK_SUBTITLE') | translate: { count: businesses.length } }}
      </h4>
      <p class="fas-muted">
        {{ namedBusinesses }}
        <span *ngIf="otherBusinesses">{{ 'FLEXI_SETTINGS.BULK_MORE' | translate: { count: otherBusinesses } }}</span>
      </p>
    </section>

    <!-- The only part that scrolls: everything below stays anchored above the buttons.
         A div rather than a fieldset: a fieldset's content box does not shrink in a
         flex column, so the list would overflow onto the section below it. -->
    <div class="fab-section fab-section--list" role="group" aria-labelledby="fab-advisors-heading">
      <h4 class="fab-heading" id="fab-advisors-heading">
        {{ 'FLEXI_SETTINGS.BULK_ADVISORS' | translate }}
        <span class="fas-muted">{{ 'FLEXI_SETTINGS.BULK_ORDER_HINT' | translate }}</span>
      </h4>
      <ul class="fab-advisors">
        <li *ngFor="let advisor of selectable">
          <label class="fab-advisor" [class.fab-advisor--ticked]="order(advisor.UserId)">
            <input type="checkbox" [checked]="!!order(advisor.UserId)" (change)="toggle(advisor.UserId)" />
            <span class="fas-avatar" aria-hidden="true">{{ initials(advisor.Name) }}</span>
            <span class="fab-advisor__name">{{ advisor.Name }}</span>
            <span class="fab-advisor__order" *ngIf="order(advisor.UserId)">#{{ order(advisor.UserId) }}</span>
          </label>
        </li>
      </ul>
    </div>

    <fieldset class="fab-section">
      <legend class="fab-heading">{{ 'FLEXI_SETTINGS.BULK_EXISTING' | translate }}</legend>
      <label class="fab-mode" [class.fab-mode--active]="mode === 'Append'">
        <input type="radio" name="fab-mode" [checked]="mode === 'Append'" (change)="modeChanged('Append')" />
        <span>
          <strong>{{ 'FLEXI_SETTINGS.BULK_APPEND' | translate }}</strong>
          <span class="fas-muted">{{ 'FLEXI_SETTINGS.BULK_APPEND_HINT' | translate }}</span>
        </span>
      </label>
      <label class="fab-mode" [class.fab-mode--active]="mode === 'Replace'">
        <input type="radio" name="fab-mode" [checked]="mode === 'Replace'" (change)="modeChanged('Replace')" />
        <span>
          <strong>{{ 'FLEXI_SETTINGS.BULK_REPLACE' | translate }}</strong>
          <span class="fas-muted">{{ 'FLEXI_SETTINGS.BULK_REPLACE_HINT' | translate }}</span>
        </span>
      </label>
    </fieldset>

    <div class="fab-warning" *ngIf="removals.length" role="alert">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <div>
        <strong>{{ 'FLEXI_SETTINGS.BULK_REPLACE_WARNING' | translate }}</strong>
        <ul>
          <li *ngFor="let removal of removals">
            {{ 'FLEXI_SETTINGS.BULK_REMOVES' | translate: { advisors: removal.advisorNames.join(', '), business: removal.businessName } }}
          </li>
        </ul>
      </div>
    </div>

    <p class="fas-error" *ngIf="saveFailed" role="alert">{{ 'FLEXI_SETTINGS.BULK_FAILED' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="fas-dialog-actions">
      <button type="button" class="fas-btn fas-btn--ghost" (click)="cancel()">
        {{ 'FLEXI_SETTINGS.CANCEL' | translate }}
      </button>
      <button type="button" class="fas-btn fas-btn--primary" [disabled]="!ticked.length || saving" (click)="submit()">
        <i class="pi pi-spin pi-spinner" *ngIf="saving" aria-hidden="true"></i>
        {{ (businesses.length === 1 ? 'FLEXI_SETTINGS.BULK_SUBMIT_ONE' : 'FLEXI_SETTINGS.BULK_SUBMIT') | translate: { count: businesses.length } }}
      </button>
    </div>
  </ng-template>
</p-dialog>
